import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FeaturesConfigSearchForm, FeaturesConfigShipmentForm, FeaturesFlowType } from 'src/app/shared/models/config';
import { ConfigService } from 'src/app/shared/services';

@Component({
    standalone: true,
    selector: 'app-half-background',
    templateUrl: './half-background.component.html',
    styleUrls: ['./half-background.component.scss'],
    imports: [CommonModule, NgOptimizedImage],
})
export class HalfBackgroundComponent implements OnInit {
    public centerBackgroundImages: boolean = false;
    public backgroundColor: string = 'transparent';
    public selectedImage = '';
    private searchFormConfig?: FeaturesConfigSearchForm | null;
    private shipmentFormConfig?: FeaturesConfigShipmentForm | null;

    @Input() images: string[] = [];
    @Input() shadow = true;
    @Input() alt = 'Facility background image';

    constructor(private readonly configService: ConfigService) {}

    ngOnInit(): void {
        this.getSearchFormConfiguration();
        this.getShipmentFormConfiguration();
        this.setRandomImage();
        this.setBackgroundColor();
    }

    setRandomImage(): void {
        this.centerBackgroundImages = this.configService.getCenterBackgroundImages();
        if (this.images.length) {
            const randomImage = Math.floor(Math.random() * this.images.length);

            this.selectedImage = this.images[randomImage];
        }
    }

    getSearchFormConfiguration(): void {
        this.searchFormConfig = this.configService.getSearchFormConfig();
    }

    getShipmentFormConfiguration(): void {
        this.shipmentFormConfig = this.configService.getShipmentFormConfig();
    }

    setBackgroundColor(): void {
        switch (this.checkFlowType()) {
            case FeaturesFlowType.SEARCH_FORM:
                this.backgroundColor = this.searchFormConfig?.backgroundColor || 'transparent';
                break;
            case FeaturesFlowType.SHIPMENT_FORM:
                this.backgroundColor = this.shipmentFormConfig?.backgroundColor || 'transparent';
                break;
            default:
                this.backgroundColor = 'transparent';
        }
    }

    checkFlowType(): FeaturesFlowType | undefined {
        return this.configService.getFeaturesFlowType();
    }
}
